import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';

const Spinner = ({ loading }) => {
  return (
    <div
      style={{
        display: loading ? 'flex' : 'none',
        justifyContent: 'center',
        margin: '40px 0px',
      }}
    >
      <CircularProgress />
    </div>
  );
};

Spinner.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/Spinner.jsx